import type { IOnChangesObject } from 'angular';

function ExternalController(
  $scope: todo,
  $rootScope: todo,
  ExternalAuth: todo,
) {
  const {
    reactExternalAuth,
    labelOverrideMap,
    getAvailability,
    getLabel,
    setAuth,
  } = $scope.$parent.$ctrl;
  $rootScope.reactExternalAuth = reactExternalAuth;
  $rootScope.labelOverrideMap = labelOverrideMap;
  $rootScope.getAvailability = getAvailability;
  $rootScope.getLabel = getLabel;

  // eslint-disable-next-line no-param-reassign
  ExternalAuth.auth = reactExternalAuth;
  // eslint-disable-next-line no-param-reassign
  ExternalAuth.setAuth = setAuth;

  // copied from Default.controller
  $scope.$parent.$ctrl.$onChanges = (changesObj: IOnChangesObject) => {
    Object.entries(changesObj).forEach(([key, value]) => {
      if (key === 'reactExternalAuth') {
        Object.assign($rootScope.reactExternalAuth, value.currentValue);
      } else {
        $rootScope[key as string] = value.currentValue;
      }
    });
  };
}

ExternalController.$inject = ['$scope', '$rootScope', 'ExternalAuth'];

export default ExternalController;
